import { PropsWithChildren, FC } from 'react'
// import Card from '@/pages/Tbqy/components/components/Card'
import Card from '@/components/CollapseCard'
import Top from './Top'
import Ydtj from './Ydtj'
import Gbmndtj from './Gbmndtj'

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {

  return (
    <Card
      title={
        <div className='font-15 font-700 mr-20'>成本支出数据统计</div>
      }
      hideCollapse
      items={
        [
          {label: `已支付`, key: '已支付', children: <Child updateTime={updateTime} />},
          {label: `已记账`, key: '已记账', children: <Child updateTime={updateTime} />},
          {label: `待记账`, key: '待记账', children: <Child updateTime={updateTime} />},
          {label: `应付`, key: '应付', children: <Child updateTime={updateTime} />},
        ]
      }
    >
    </Card>
  )
}

const Child = ({updateTime}) => {
  return (
    <div>
      <Top updateTime={updateTime} />
      <div className='mt-30 border-top pt-24 mlr-10'>
        <div className='' style={{height: '300px'}}>
          <Ydtj updateTime={updateTime} />
        </div>
        <div className='border-top pt-20 mt-10' style={{height: '300px'}}>
          <Gbmndtj updateTime={updateTime} />
        </div>
      </div>
    </div>
  )
}

export default Component
